/* eslint-disable no-dupe-keys */
export default {
  service_provider: {
    name: '运营商',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '运营商名称',
      logo: 'Logo',
      short_name: '简称',
      operator_id: '组织机构代码',
      unified_social_credit_code: '统一社会信用代码',
      phone: '联系电话',
      parent_id: '上级运营商',
      sort_number: '排序编号',
      theme: '主题色',
      address: '地址',
      node_path: '节点',
      children_count: '加盟商数量',
      ev_charging_stations_count: '站数量',
      illustration: '插图',
      support_receipt: '支持开票',
      settlement_rule: '结算规则',
      sp_type: '类型',
      user_mobile_visible: '显示用户手机',
      note: '备注',
      account_balance: '账户余额',
      last_settled_at: '上次结算时间',
      title: '标题',
      domain: '域名',
      bank_account_name: '银行卡户名',
      bank_account_number: '银行卡账号',
      bank_name: '开户行',
      invoice_mobile: '开票联系人手机',
      is_support_update_billing_rule: '支持自定义费率',
      withdraw_model: '提现方式',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      account_balance: '账户余额'
    },
    // Enum的属性
    sp_types: {
      directly: '平台直属',
      evcs: '互联互通',
      third_party: '第三方',
      shop: '商店'
    },
    user_mobile_visibles: {
      true: '显示',
      false: '隐藏'
    },
    titles: {
      base_info: '基本信息',
      org_tree: '组织结构'
    },
    is_support_update_billing_rules: {
      true: '是',
      false: '否'
    },
    withdraw_models: {
      self_withdrawal: '自提现',
      proxy_withdrawal: '代提现',
      auto_withdrawal: '自动提现'
    },
    // 占位提示
    placeholder: {
      search_keyword: '查询名称/组织机构代码',
      domain_placeholder: '运营商的域名',
      title_placeholder: '浏览器顶部标签页的标题'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      ev_charging_stations: '充电站',
      orders: '订单',
      order_statistics: '订单统计',
      settlement_rules: '结算规则',
      ev_charging_station_settlements: '站结算记录',
      order_settlements: '订单结算记录',
      service_provider_withdraw_applications: '运营商提现',
      configure: '配置'
    },
    placeholders: {
      input_operator_id: '企业的组织机构代码（9位），互联互通使用',
      input_unified_social_credit_code: '企业的统一社会信用代码（18位）'
    },
    detail_tips: {
      base_info: '基础信息',
      bank_info: '收款账户'
    },
    configure_info: {
      receipt_setting: '发票设置',
      theme: '主题风格',
      edit_receipt: '修改发票配置'
    },
    receipt_setting: {
      attrs: {
        supported_receipt_types: '支持开票的类型',
        receipt_content: '发票内容',
        min_amount: '开票起始金额',
        notice: '用户需知'
      },
      placeholders: {
        notice: '发票内容按电费和服务费开具',
        invoice_mobile_notice: '如果运营商存在未开票申请记录，每天下午3点短信通知该联系人'
      },
      not_supported_any_receipt_type: '不支持开票',
      receipt_types: {
        vat_electronic_general: '电子普通发票',
        vat_general: '普通发票（纸质）'
      }
    },
    enterprise_icon: '企业图标',
    enterprise_logo: {
      show: {
        success: 'Logo上传成功',
        logo: '推荐尺寸250*250，PNG格式，大小尺寸不超过1M',
        logo_information:
          '<div style="text-align:left;">应用场景:<br/>1. 登录页面中间 logo 图片<br/>2. 当前运营商 logo（运营商详情页与管理后台顶部中间的图标）<br/>3. 管理后台实时监控 &gt; 监控大屏 &gt; 白色风格的监控页面使用</div>',
        logo_placeholder: '上传运营商LOGO',
        light_logo: '推荐尺寸250*250，PNG格式，大小尺寸不超过1M',
        light_logo_information: '<div style="text-align:left;">应用场景:<br/>1. 管理后台实时监控 &gt; 监控大屏 &gt; 黑色风格的监控页面使用</div>',
        light_logo_placeholder: '上传运营商浅色LOGO',
        favicon_ico: '推荐尺寸64*64，ico格式，大小尺寸不超过50kb',
        favicon_ico_information: '<div style="text-align:left;">应用场景:<br/>1. 浏览器工具栏图标<br/>2. 浏览器收藏夹图标</div>',
        favicon_ico_placeholder: '上传运营商Favicon',
        hover_text: '点击或拖拽图片以修改',
        notice_logo_text: '默认Logo',
        notice_light_logo_text: '浅色Logo',
        notice_favicon_text: '浏览器工具栏图标(favicon.ico）'
      }
    },
    alerts: {
      auto_withdrawal: '每天9点自动提现昨天00:00后结算的记录'
    }
  }
}
